import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import MaterialTable from "material-table";
import { forwardRef } from 'react';
import classNames from 'classnames';
import compose from 'recompose/compose';
// Material helpers
import { withStyles } from '@material-ui/core/styles';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import { api_host, api_auth } from '../../../../../../common/globals/constants';

import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import TextField from '@material-ui/core/TextField/index';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Divider from '@material-ui/core/Divider';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';

import IconButton from '@material-ui/core/IconButton';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import moment from 'moment'
import 'moment/locale/es'  
import { Button, Grid } from '@material-ui/core';
//import {templateView} from '../../../../../../services/Templates'
// Component styles
import styles from './styles';
import { typography } from '@material-ui/system';

moment.locale('es')

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};
const sendValues = (value, nombre, destinatario, telefono, tipo, 
                    notificacion_destinatario_id, descripcion, template, inputList) => {
    let token = sessionStorage.getItem('key')
    let client_id = sessionStorage.getItem('client_id')
    let method = 'POST'
    if (value == 2){
        method = 'PATCH'
    }
    if (value == 3){
        method = 'DELETE'
    }
    return new Promise(resolve => {
        setTimeout(() => {
            fetch(api_host+`/reporte/general/destinatarios_extendido/?token=${token}`, {
                method: method, // or 'PUT'
                body: JSON.stringify({token: token, nombre: nombre, destinatario: destinatario, telefono: telefono, 
                    notificacion_tipo_id: tipo, notificacion_destinatario_id: notificacion_destinatario_id, cliente_id: client_id,
                    descripcion: descripcion, id_template_id:template, meta_data: inputList}), // data can be `string` or {object}!
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => res.json())
                .catch(error => console.error('Error:', error))
                .then(response => {
                    if (response.status == 3) {
                        resolve(false);
                    } else {
                        resolve(true);
                    }
                }
                );
        }, 100);
    });
};

class AddresseeExtendedAdd extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            step: null,
            hoverData: null,
            lastEvent: [],
            //statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            rows: null,
            noMonCum: null,
            downCum: null,
            //date: this.props.params.date,
            dateMoment: ((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")),
            addEl: null,
            editEl: null,
            deleteEl: null,
            values: {
                destiny: '',
                confirm: '',
                name: '',
                phone: '',
                type: 2,
                addresseeId: 0,
                description: '',
                template: '',
                host: 'endpoint / host',
                action: 'action',
                content: 'content_type',
                actionValue: 0
            },
            open: false,
            isValid: false,
            validEmail: true,
            validName: true,
            validDescription: true,
            validValorHost: true,
            validValorAction: true,
            validValorContent: true,
            validTemplate: true,
            //isRefresh: this.props.params.isRefresh,
            inputList: [],
            templateList: [],
            contHeader: 0,
            actionValues:['GET', 'HEAD', 'POST' , 'PUT', 'DELETE', 'CONNECT', 'OPTIONS', 'TRACE', 'PATCH', 'Otro(s)'],
            errorStates:["Ha ocurrido un error, intente nuevamente.","Ingrese nombre", "Ingrese destinatario", 
            "Ingrese descripción", "Ingrese enpoint/host", "Seleccione action", "Ingrese content_type", "Seleccione template" ],
            errorStatesValue: 0,
            validValue: 0,
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        return null;
    }


    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentWillUnmount() {

    }

    getDataFromAPI = (objectiveId) => {
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        fetch(api_host+`/reporte/general/Template/?user=${user}&token=${token}&method=view`)
                .then(response => response.json())
                .then( myJson =>  {
                    try {
                        this.processData(myJson)
                    } catch (error) {
                    this.setState({
                        dataError: true,
                        data: null,
                        isLoading: false
                    });
                }
            });
            
    }

    // Helper para procesar la data de la petición a la API

    processData = (data) => {
        this.setState({
            templateList : data,
            //noMonCum : noMonCumDate,
            //downCum : downCumDate,
            isLoading: false,
            //time: period,
            //step: step,
            dataError: false,
        }); 
    }

    handleShowAdd = event => {
        this.setState({
            addEl: event.currentTarget,
            values:{
                type: 2,
            }
        });
    };

    handleCloseAdd = () => {
        this.setState({
            addEl: null,
            validEmail: false,
            validName: false,
        });
    };

    handleShowEdit = (event, value) => {
        this.setState({
            editEl: event.currentTarget,
            values:{
                destinyEdit: value.destinatario,
                nameEdit: value.nombre,
                phoneEdit: value.telefono,
                typeEdit: value.tipoId,
                addresseeId: value.notificacionDestinatarioId
            }
        });
    };

    handleCloseEdit = () => {
        this.setState({
            editEl: null,
            validEmail: false,
            validName: false,
        });
    };

    handleShowDelete = (event, value) => {
        this.setState({
            deleteEl: event.currentTarget,
            values:{
                name: value.nombre,
                addresseeId: value.notificacionDestinatarioId
            }
        });
    };

    handleCloseDelete = () => {
        this.setState({
            deleteEl: null
        });
    };

    handleFieldChange = (field, value) => {
        const newState = { ...this.state };
        newState.values[field] = value;     
        this.setState(newState);
    };

    handleFieldChangeHeaders = (field, value) => {
        const newState = { ...this.state };
        newState.inputList.map((x, i) => {
                if(Object.entries(x)[0][0] == field){
                    x[field] = value
                }
                if(Object.entries(x)[1][0] == field){
                    x[field] = value
                }
            } 
        )   
        this.setState(newState);
    };

    handleSaved = async () => {
        const {values, inputList, actionValues} = this.state;

        if (!values.name) {
            this.setState({
                isValid: false,
                errorStatesValue: 1,
                open: true
            });
            return;
        }
        if (!values.destiny) {
            this.setState({
                isValid: false,
                errorStatesValue: 2,
                open: true
            });
            return;
        }
        if (!values.description){
            this.setState({
                isValid: false,
                errorStatesValue: 3,
                open: true
            });
            return
        }
        if (!values.template){
            this.setState({
                isValid: false,
                errorStatesValue: 7,
                open: true
            });
            return
        }
        if (!values.hostValue){
            this.setState({
                errorStatesValue: 4,
                isValid: false,
                open: true
            });
            return
        }
        if (values.actionValue < 0 || values.actionValue > actionValues.length - 1){
            this.setState({
                isValid: false,
                errorStatesValue: 5,
                open: true
            });
            return
        }
        if (!values.contentValue){
            this.setState({
                errorStatesValue: 6,
                isValid: false,
                open: true
            });
            return
        }

        const newValue = 1
        const nombre = values.name
        const destinatario = values.destiny
        const telefono = values.phone
        const tipo = "7"        
        const descripcion = values.description
        const template = parseInt(values.template)
        var notificacion_destinatario_id = 0 

        const newInputList = [...inputList]
        newInputList.push({'host':values.host, 'value':values.hostValue})
        newInputList.push({'action':values.action, 'value':actionValues[values.actionValue]})
        newInputList.push({'content':values.content, 'value':values.contentValue})
        
        const inputListFix = newInputList.filter(
            element => (element.host !== 'endpoint / host' && element.action !== 'action' && element.content !== 'content_type')
        );

        this.setState({ isLoading: true });
        try {
            //const ok = true
            const ok = await sendValues(newValue, nombre, destinatario, telefono, tipo, 
                                        notificacion_destinatario_id, descripcion, template, newInputList);
            if (!ok){
                throw new Error('Error al registrar el contacto')
            }
            this.setState({
                isLoading: true,
                isValid: true,                   
                open: true,
                inputList: inputListFix,
            });
            this.getDataFromAPI();
        } catch (error) {
            this.setState({
                isLoading: false,
                errorStatesValue: 0,
                isValid: false,
                open: true,
                validValue: 1,
                inputList: inputListFix
            });
        }
    }

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            open: false 
        })
        if (this.state.isValid){
            this.props.handleCloseAdd()
        }
    };
    
    validateEmail = (email) => {
        var re = /\S+@\S+\.\S+/;      
        if (re.test(email)) {
            this.setState({
                validEmail: true,
                validValue: 0
            });
        } else {
            this.setState({
                validEmail: false,
                validValue: 1
            });
        }
    }

    validateName = (name) => {
        if (!name) {
            this.setState({
                validName: false,
                validValue: 1
            });
        } else {
            this.setState({
                validName: true,
                validValue: 0
            });
        }
    }

    validateDescription = (name) => {
        if (!name) {
            this.setState({
                validDescription: false,
                validValue: 0
            });
        } else {
            this.setState({
                validDescription: true,
                validValue: 1
            });
        }
    }

    validateHost = (name) => {
        if (!name) {
            this.setState({
                validValorHost: false,
                validValue: 0
            });
        } else {
            this.setState({
                validValorHost: true,
                validValue: 1
            });
        }
    }

    validateAction = (name) => {
        if (!name) {
            this.setState({
                validAction: false,
                validValue: 0
            });
        } else {
            this.setState({
                validAction: true,
                validValue: 1
            });
        }
    }

    validateContent = (name) => {
        if (!name) {
            this.setState({
                validValorContent: false,
                validValue: 0
            });
        } else {
            this.setState({
                validValorContent: true,
                validValue: 1
            });
        }
    }

    validateTemplate = (name) => {
        if (!name) {
            this.setState({
                validTemplate: false,
                validValue: 0
            });
        } else {
            this.setState({
                validTemplate: true,
                validValue: 1
            });
        }
    }

    // handle click event of the Remove button
    handleRemoveClick = () => {
        const newState = { ...this.state };
        var cont = newState.inputList.length
        newState.inputList.pop()
        if (cont > 0) {
            newState.inputList.length = cont - 1
        }
        this.setState(newState)
    };
   
    // handle click event of the Add button
    handleAddClick = () => {
        const newState = { ...this.state };
        var cont = newState.inputList.length
        var name = 'nameHeader'+cont
        var value = 'valorHeader'+cont
        newState.inputList.push({[name]:'',[value]:''})
        this.setState(newState)
    };


    render() {
        const { classes, className, ...rest } = this.props;
        const { dataError, isLoading, rows, noMonCum, downCum, addEl, editEl, deleteEl, open, isValid, 
                validEmail, validName, inputList, validDescription, templateList,
                validValorHost, validValorContent, validValorAction, errorStates, errorStatesValue,
                validTemplate} = this.state;
        const {destinyEdit, nameEdit, phoneEdit, typeEdit, name, template, actionValue } = this.state.values
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };    
        const showAddEl = Boolean(addEl);   
        const showEditEl = Boolean(editEl); 
        const showDeleteEl = Boolean(deleteEl); 
        const rootClassName = classNames(classes.root, className);
  
        if (!dataError) {
            return (<FormattedChart classes={classes} rows={rows} noMonCum={noMonCum} downCum={downCum} isLoading={isLoading} style={style} styleHidden={styleHidden}
                                    handleCloseAdd={this.props.handleCloseAdd} handleShowAdd={this.handleShowAdd} showAddEl={showAddEl}
                                    handleFieldChange={this.handleFieldChange}
                                    handleCloseEdit={this.handleCloseEdit} handleShowEdit={this.handleShowEdit} showEditEl={showEditEl} 
                                    destinyEdit={destinyEdit} nameEdit={nameEdit} phoneEdit={phoneEdit} typeEdit={typeEdit}
                                    handleDeleted={this.handleDeleted} handleSaved={this.handleSaved}
                                    open={open} isValid={isValid} handleClose={this.handleClose}
                                    handleCloseDelete={this.handleCloseDelete} handleShowDelete={this.handleShowDelete} showDeleteEl={showDeleteEl}
                                    name={name} validEmail={validEmail} validateEmail={this.validateEmail} 
                                    validName={validName} validateName={this.validateName}
                                    handleAddClick={this.handleAddClick} handleRemoveClick={this.handleRemoveClick}
                                    inputList={inputList} templateList={templateList}
                                    validDescription={validDescription} validateDescription={this.validateDescription}
                                    template={template} handleFieldChangeHeaders={this.handleFieldChangeHeaders}
                                    validValorHost={validValorHost} validValorContent={validValorContent} validValorAction={validValorAction}
                                    validateHost={this.validateHost} validateAction={this.validateAction} validateContent={this.validateContent}
                                    errorStates={errorStates} errorStatesValue={errorStatesValue}
                                    validateTemplate={this.validateTemplate} validTemplate={validTemplate}
                                    actionValue={actionValue}/>) 
        }
        else if (dataError) {
            return (<p>No hay datos..</p>)
        }
        else return (<p> Error!</p >)

    }
}

function FormattedChart(props) {
    return (
        <div>
            { props.isLoading &&
                <PortletContent style={{alignItems: 'center', position: 'absolute', top: '20%', left: '50%'}}>
                    <PerfectScrollbar>

                        <Typography
                        variant="h5"
                        style={{color:'white'}}
                        >
                        <CircularProgress
                        variant="indeterminate"

                        size={24}
                        thickness={4}
                        
                        />
                        <br/>
                        Cargando Información...
                    </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            }
                <div style={{ maxWidth: "100%" }}>
                   <PerfectScrollbar>
                        <div >                             
                            <Portlet style={{marginBottom: 20}}
                            >
                                <PortletHeader style={{justifyContent:'normal'}}>
                                    <IconButton onClick={props.handleCloseAdd}>
                                        <ArrowBackIcon/>
                                    </IconButton>
                                    <PortletLabel
                                        //subtitle="Actualizar Contraseña"
                                        title="Información de contacto extendido"
                                    />
                                </PortletHeader>
                                <PortletContent>
                                    <form autoComplete="off" noValidate className={props.classes.form}>
                                        <Grid container spacing={2} style={{marginTop: 10}}>
                                            <Grid item lg={6} md={6} sm={12}>
                                                <TextField
                                                    className={props.classes.textFieldNew}
                                                    label="Nombre"
                                                    name="name"
                                                    onChange={event =>
                                                        props.handleFieldChange('name', event.target.value)
                                                    }
                                                    type="text"
                                                    required
                                                    onBlur={event =>
                                                        props.validateName(event.target.value)
                                                    }
                                                    error={!props.validName}
                                                    helperText={!props.validName ? 'Por favor ingrese un nombre válido' : ''}
                                                    
                                                    variant="outlined"
                                                    fullWidth
                                                    value={props.name}
                                                />
                                                <TextField
                                                    onBlur={event =>
                                                        props.validateEmail(event.target.value)
                                                    }
                                                    error={!props.validEmail}
                                                    helperText={!props.validEmail ? 'Por favor ingrese un email válido' : ''}
                                                    className={props.classes.textFieldNew}
                                                    label="Casilla de Destino"
                                                    name="destiny"
                                                    required
                                                    onChange={event =>
                                                        props.handleFieldChange('destiny', event.target.value)
                                                    }
                                                    type="email"
                                                    //value={values.newPass}
                                                    variant="outlined"
                                                    fullWidth
                                                    value={props.destiny}
                                                />
                                                <TextField
                                                    onBlur={event =>
                                                        props.validateDescription(event.target.value)
                                                    }
                                                    error={!props.validDescription}
                                                    helperText={!props.validDescription ? 'Por favor ingrese una descripción válida' : ''}
                                                    className={props.classes.textFieldNew}
                                                    label="Descripción"
                                                    name="description"
                                                    required
                                                    onChange={event =>
                                                        props.handleFieldChange('description', event.target.value)
                                                    }
                                                    variant="outlined"
                                                    fullWidth
                                                    value={props.description}
                                                />
                                                <FormControl variant="filled" className={props.classes.formControl}>
                                                    <InputLabel htmlFor="age-native-helper">Asignar template</InputLabel>
                                                    <Select
                                                        className={props.classes.textFieldNew}
                                                        name="template"
                                                        onChange={event =>
                                                            props.handleFieldChange('template', event.target.value)
                                                        }
                                                        required
                                                        native
                                                        value={props.template}
                                                        onBlur={event =>
                                                            props.validateTemplate(event.target.value)
                                                        }
                                                        error={!props.validTemplate}
                                                        helperText={!props.validTemplate ? 'Por favor seleccione un template' : ''}
                                                        fullWidth
                                                    >
                                                        <option value={''}></option>
                                                        {props.templateList['dataTemplate'] &&
                                                            <>
                                                                {Object.keys(props.templateList['dataTemplate']).map((key) => (
                                                                    <option value={props.templateList['dataTemplate'][key].id}>{props.templateList['dataTemplate'][key].nombre+' - '+props.templateList['dataTemplate'][key].descripcion}</option>
                                                                ))}
                                                            </>
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </form>
                                </PortletContent>
                            </Portlet>
                            <Portlet>
                                    <PortletHeader >
                                        <PortletLabel
                                            title="MetaData de integración"
                                        />
                                        <div >
                                            <Typography>Agregar header</Typography>                                          
                                            <IconButton onClick={props.handleAddClick}><AddCircleOutlineIcon/></IconButton>
                                            <IconButton onClick={props.handleRemoveClick}><RemoveCircleOutlineIcon/></IconButton>
                                        </div>
                                    </PortletHeader>
                                    <PortletContent>
                                        <form autoComplete="off" noValidate className={props.classes.form}>
                                        <Grid container spacing={2} style={{marginTop: 10, marginBottom: 20}}>
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                            <TextField
                                                label="Nombre"
                                                name="host"
                                                value="endpoint / host"
                                                onChange={event =>
                                                    props.handleFieldChange('host', event.target.value)
                                                }
                                                type="text"
                                                disabled
                                                variant="outlined"
                                                fullWidth
                                            />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                            <TextField
                                                label="Valor"
                                                name="hostValue"
                                                onChange={event =>
                                                    props.handleFieldChange('hostValue', event.target.value)
                                                }
                                                type="text"
                                                placeholder='https://api-i.atentus.com'
                                                required
                                                onBlur={event =>
                                                    props.validateHost(event.target.value)
                                                }
                                                error={!props.validValorHost}
                                                helperText={!props.validValorHost ? 'Por favor ingrese un valor válido' : ''}
                                                variant="outlined"
                                                fullWidth
                                            />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                            <TextField
                                                label="Nombre"
                                                name="action"
                                                value="action"
                                                onChange={event =>
                                                    props.handleFieldChange('action', event.target.value)
                                                }
                                                type="text"
                                                disabled
                                                variant="outlined"
                                                fullWidth
                                            />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                            <FormControl variant="filled" className={props.classes.formControl} required>
                                                <InputLabel htmlFor="age-native-required">Valor</InputLabel>
                                                <Select
                                                    name="actionValue"
                                                    onChange={event =>
                                                        props.handleFieldChange('actionValue', event.target.value)
                                                    }
                                                    native
                                                    required
                                                    value={props.actionValue}
                                                    variant="filled"
                                                    fullWidth
                                                > 
                                                    <option value={0}>GET</option>
                                                    <option value={1}>HEAD</option>
                                                    <option value={2}>POST</option>
                                                    <option value={3}>PUT</option>
                                                    <option value={4}>DELETE</option>
                                                    <option value={5}>CONNECT</option>
                                                    <option value={6}>OPTIONS</option>
                                                    <option value={7}>TRACE</option>
                                                    <option value={8}>PATCH</option>
                                                    <option value={9}>Otro(s)</option>
                                                </Select>
                                            </FormControl>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                            <TextField
                                                label="Nombre"
                                                name="content"
                                                value="content_type"
                                                onChange={event =>
                                                    props.handleFieldChange('content', event.target.value)
                                                }
                                                type="text"
                                                disabled
                                                variant="outlined"
                                                fullWidth
                                            />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                            <TextField
                                                label="Valor"
                                                name="contentValue"
                                                onChange={event =>
                                                    props.handleFieldChange('contentValue', event.target.value)
                                                }
                                                required
                                                placeholder='document/json'
                                                onBlur={event =>
                                                    props.validateContent(event.target.value)
                                                }
                                                error={!props.validValorContent}
                                                helperText={!props.validValorContent ? 'Por favor ingrese un valor válido' : ''}
                                                //helperText="Incorrect entry."
                                                variant="outlined"  
                                                fullWidth
                                            />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                        {props.inputList.map((x, i) => (
                                            <>
                                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                                <TextField
                                                    label="Nombre"
                                                    name={"header"+i}
                                                    onChange={event =>
                                                        props.handleFieldChangeHeaders(('nameHeader'+i), event.target.value)
                                                    }
                                                    type="text"
                                                    required
                                                    variant="outlined"
                                                    fullWidth
                                                />
                                                </Grid>
                                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                                <TextField
                                                    label="Valor"
                                                    name={"valorHeader"+i}
                                                    onChange={event =>
                                                        props.handleFieldChangeHeaders(('valorHeader'+i), event.target.value)
                                                    }
                                                    type="text"
                                                    required
                                                    variant="outlined"
                                                    fullWidth
                                                />
                                                </Grid>
                                            </>
                                            ))
                                        }
                                        </Grid>
                                    </form>
                                </PortletContent>
                                <PortletFooter className={props.classes.portletFooter} align="center">
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        onClick={props.handleSaved}
                                        style={{marginRight: 10}}
                                        disabled={props.isLoading}
                                    >
                                        Guardar
                                    </Button>
                                    <Button
                                        color="primary"
                                        variant="outlined"
                                        onClick={props.handleCloseAdd}
                                        disabled={props.isLoading}
                                    >
                                        Cancelar
                                    </Button>
                                </PortletFooter>
                            </Portlet>                          
                        </div>
                    </PerfectScrollbar>
                    
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        open={props.open}
                        autoHideDuration={2000}
                        onClose={props.handleClose}
                        >
                            <SnackbarContent
                                className={props.isValid ? props.classes.snackContentOk
                                            : props.classes.snackContent}
                                aria-describedby="client-snackbar"
                                message={
                                    props.isValid ?
                                            <span id="client-snackbar" className={props.classes.message}>
                                                <CheckCircleIcon className={(props.classes.icon, props.classes.iconVariant)}/>
                                                Proceso Exitoso
                                            </span>
                                        :	<span id="client-snackbar" className={props.classes.message}>
                                                <ErrorIcon className={(props.classes.icon, props.classes.iconVariant)}/>
                                                {props.errorStates[props.errorStatesValue]}
                                            </span>
                                }
                                action={[
                                    <IconButton key="close" aria-label="close" color="inherit" onClick={props.handleClose}>
                                        <CloseIcon className={props.classes.icon}/>
                                    </IconButton>
                                ]}
                            />
                    </Snackbar>
                </div>
            </div>
        )
}

export default compose(withRouter, withStyles(styles))(AddresseeExtendedAdd);